import {
  type Parent,
  type UnitRelationLookupOptions,
} from './RelationDivisionLine/RelationDivisionLine.types';
import { type RouterOutputs } from '@/config/trpc';

import { createContextWithHooks } from '@/shared/utils/react';

type ParentContextType = Parent;

type UnitRelationOption =
  RouterOutputs['hoa']['building']['relation']['unitRelationsAutocomplete'][number];

type RelationAutocompleteContextSchema = {
  params: {
    setShowOldRelations: (value: boolean) => void;
    showOldRelations: boolean;
  };
  query: {
    data: UnitRelationOption[];
    isLoading: boolean;
    selectors: {
      getAvailableOptions: (currentDivision?: UnitRelationLookupOptions) => UnitRelationOption[];
      getOption: (currentDivision: UnitRelationLookupOptions) => UnitRelationOption | undefined;
    };
  };
};

const BASE_NAME = 'relation-division-lines';
const RELATION_AUTOCOMPLETE_NAME = `${BASE_NAME}-relation-autocomplete`;

const DISPLAY_NAMES = {
  PARENT: `${BASE_NAME}-parent`,
  RELATION_AUTOCOMPLETE: {
    PARAMS: `${RELATION_AUTOCOMPLETE_NAME}.params`,
    QUERY: `${RELATION_AUTOCOMPLETE_NAME}.query`,
  },
} as const;

const relationDivisionLinesCtx = {
  parent: createContextWithHooks<ParentContextType>(DISPLAY_NAMES.PARENT),
  relationAutocomplete: {
    params: createContextWithHooks<RelationAutocompleteContextSchema['params']>(
      DISPLAY_NAMES.RELATION_AUTOCOMPLETE.PARAMS,
    ),
    query: createContextWithHooks<RelationAutocompleteContextSchema['query']>(
      DISPLAY_NAMES.RELATION_AUTOCOMPLETE.QUERY,
    ),
  },
};

export default relationDivisionLinesCtx;
